export default "__VITE_ASSET__CjXbZb7f__"